/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IWineClubInputProps } from './wine-club.types';

//==============================================================================
/**
 * WineClubInputText component
 * @extends {React.Component<IWineClubInputProps>}
 */
//==============================================================================
@observer
class WineClubInputText extends React.Component<IWineClubInputProps> {

    //==========================================================================
    // Variables
    //==========================================================================

    @observable private error: boolean = false;

    //==========================================================================
    // Public Methods
    //==========================================================================

    public render(): JSX.Element {
        return (
            <div className='form-group'>
                <label>
                    {this.props.label}{this.props.required && '*'}
                    <input
                        className='form-control'
                        type={this.props.type}
                        id={this.props.id}
                        data-group={this.props.group && this.props.group}
                        required={this.props.required}
                        value={this.props.value}
                        onChange={this.props.handleChange}
                        // If field has specified validation, validate field on input blur.
                        onBlur={
                            this.props.validation &&
                            (event => this._blurInput(event, this.props.validation!.validate))
                        }
                    />
                </label>
                {this.props.validation && this.error && this.props.renderValidation!(this.props.validation.message, 'wine-club-error')}
            </div>
        );
    }

    //==========================================================================
    // Private Methods
    //==========================================================================

    // Validates field with corresponding validation function.
    private _blurInput(event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>, validateInput: Function): void {
        validateInput(event.target.value) ? this.error = false : this.error = true;
    }
}

export default WineClubInputText;